module.exports = (thing) => !!(thing && thing.Window) && (thing instanceof thing.Window);
